import React from 'react'
import { connect } from 'react-redux'

import { SHOW_PAGE, UPDATE_ICONS } from '../actions'

import './header.css'

const Header = ({ updatePage, children, hideIcons, css }) => {
  return (
    <header className={`header text-center ${css}`}>
      {children}
      <button
        className="btn btn-cross-ranking"
        onClick={e => {
          hideIcons()
          updatePage('home')
        }}
      >
        <svg width="22" height="22">
          <path
            d="M22 2.2L19.8 0 11 8.8 2.2 0 0 2.2 8.8 11 0 19.8 2.2 22l8.8-8.8 8.8 8.8 2.2-2.2-8.8-8.8z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </svg>
      </button>
    </header>
  )
}

const mapDispatch = dispatch => {
  return {
    updatePage: page => {
      dispatch({
        type: SHOW_PAGE,
        payload: page
      })
    },

    hideIcons: () => {
      dispatch({
        type: UPDATE_ICONS,
        payload: {
          response: null,
          answered: false
        }
      })
    }
  }
}

export default connect(null, mapDispatch)(Header)



// WEBPACK FOOTER //
// ./src/components/header.js